import { ReactElement, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useWithdrawQuery } from '@/hooks/webapi/client/useWithdrawQuery';
import { withdrawDaysDiff } from '@/utils/withdrawFlow';
import * as R from '../routes';
import { WITHDRAW_MIN_BROKEN_DAYS } from '@/utils/constants';
import { useClientQuery } from '@/hooks/webapi/client/useClientQuery';

type Props = {
  children: ReactElement;
};

export default function WithdrawGuard({ children }: Props) {
  const { data: withdrawData } = useWithdrawQuery();
  const { data: client } = useClientQuery();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isWithdrawBroken =
      withdrawDaysDiff(withdrawData) >= WITHDRAW_MIN_BROKEN_DAYS;

    if (isWithdrawBroken && pathname !== R.WITHDRAW_DASHBOARD_BROKEN)
      navigate(R.WITHDRAW_DASHBOARD_BROKEN);
    if (!client?.hasOpenLoan) navigate(R.REPEATED_LOAN);
  }, [client?.hasOpenLoan, withdrawData, pathname]);

  return children;
}
